import React, { useMemo } from 'react';
import { useBoardChartData } from '../../hooks/useBoardChartData';
import { BaseChartProps } from './types';
import { CHART_COLORS } from './chartTheme';
import { useSetChartMetadata } from './ChartContext';

export const OrdersKPIChart: React.FC<BaseChartProps> = () => {
    const { finance } = useBoardChartData();

    const orders = useMemo(
        () => finance?.metrics?.orders ?? 0,
        [finance?.metrics?.orders]
    );

    const isEmpty = useMemo(() => !finance || orders === 0, [finance, orders]);

    useSetChartMetadata({ isEmpty });

    return (
        <div className="flex h-full w-full items-center justify-center [container-type:inline-size]">
            <p
                className="font-semibold text-center"
                style={{
                    color: CHART_COLORS.primary,
                    fontSize: 'clamp(1.25rem, 8cqi, 2.5rem)',
                }}
            >
                {orders.toLocaleString()}
            </p>
        </div>
    );
};
